import React from 'react'
import { List } from '@mui/material'
import { useDropzoneContext } from '../../../contexts/DropzoneContext'
import DropzoneFileListItem from './DropzoneFileListItem'

export type DropzoneFileListProps = {
	className?: string
}

const DropzoneFileList = ({ className }: DropzoneFileListProps) => {
	const { files } = useDropzoneContext()

	if (!files || files.length === 0) {
		return null
	}

	return (
		<List className={className}>
			{files.map((file) => (
				<DropzoneFileListItem
					key={`${file.name}__${file.lastModified}`}
					file={file}
				/>
			))}
		</List>
	)
}

export default DropzoneFileList
